import { addressDrawerApplyButtonStyles } from "@dana/Overrides/Widgets/Header/AddressDrawerApplyButton";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

import { css } from "styled-components";

addressDrawerApplyButtonStyles.gridItem = mergeToNew(addressDrawerApplyButtonStyles.gridItem, {
    css: css`
        justify-content: start;
        padding: 0px;
    `,
});

addressDrawerApplyButtonStyles.container = mergeToNew(addressDrawerApplyButtonStyles.container, {
    offsetCss: css`
        margin: 32px 0px 40px 0px;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin: 0px;
                    `,
                    css`
                        margin: 0px;
                    `,
                    css`
                        margin: 32px 0px 40px 0px;
                    `,
                    css`
                        margin: 32px 0px 40px 0px;
                    `,
                    css`
                        margin: 32px 0px 40px 0px;
                    `,
                ],
                "min",
            )}
    `,
});
